export const COINS_CONVERSION_TYPE = {
    COINS_CRYPTO_CONVERSION: "COINS_CRYPTO_CONVERSION",
    COINS_USD_CONVERSION: "COINS_USD_CONVERSION"
}